import { ChurchAccount } from '../models/churchAccount';

export const sortAssociatedChurchAccounts = (churchAccounts: ChurchAccount[]): ChurchAccount[] =>
  [...churchAccounts].sort(
    (firstAccount, secondAccount) => Number(Boolean(firstAccount.orgId)) - Number(Boolean(secondAccount.orgId))
  );
